
import Navbar from '../components/Navbar';
import { useEffect } from 'react';


export default function About() {

  useEffect(() => {
    const scroller = document.body
    scroller.scrollIntoView({ behavior: 'smooth' })
    scroller.scrollTo(0, 0)
  }, []);

  return (
    <>
      <div className="NavbarStyle" >
        <Navbar />
      </div>
      <div className='aboutcontainer'>

        <div className='aboutbody'>
          <h1 id='aboutmetitle'>About Me</h1>
          <br />
          <div className='normalfonttext'>
            Hello, I'm Ankur Das, a passionate and ambitious individual who is pursuing BTech in CSE (AI & ML) from Narula Institute of Technology. With a strong foundation in coding and programming, I am excited to embark on a career in the dynamic field of technology.
            <br /><br />
            Throughout my academic journey, I have honed my coding skills and developed expertise in programming languages such as Python, C, C++, Java, JavaScript, etc. I have successfully undertaken coding projects and assignments, demonstrating my ability to solve complex problems and design efficient algorithms.
            <br /><br />
            Beyond technical skills, I possess a strong desire for continuous learning and growth. I have a natural curiosity that drives me to stay updated with the latest industry trends and advancements. With an eagerness to take on new challenges, I am always seeking opportunities to expand my knowledge and expertise.
            <br /><br />
            As a BTech student, I am enthusiastic about applying my coding skills in a professional setting. I am ready to contribute to innovative projects and work alongside experienced professionals who can mentor and guide me in my career journey. My goal is to make a meaningful impact by leveraging technology to solve real-world problems.
            <br /><br />
            Thank you for taking the time to read my profile, and I look forward to connecting with professionals who share my passion for coding and technology.
          </div>
        </div>
      </div>

      <div className='aboutcontainer skillcontainer'>
        <div className='aboutbody'>
          <h1 className='skilltitle'>Skills</h1>
          <br />
          <div className='imageofskills'>

            <table className='normalfonttext'>
              <tr >
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://skillicons.dev/icons?i=python" width="48" height="48" alt="Python" /><br/>Python
                </td>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://skillicons.dev/icons?i=c" width="48" height="48" alt="C" /><br/>C
                </td>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://skillicons.dev/icons?i=cpp" width="48" height="48" alt="C++" /><br/>C++
                </td>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://skillicons.dev/icons?i=java" width="48" height="48" alt="Java" /><br/>Java
                </td>
              </tr>

              <tr>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://skillicons.dev/icons?i=html" width="48" height="48" alt="HTML" /><br/>HTML
                </td>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://skillicons.dev/icons?i=css" width="48" height="48" alt="CSS" /><br/>CSS
                </td>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://skillicons.dev/icons?i=javascript" width="48" height="48" alt="JavaScript" /><br/>JavaScript
                </td>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://skillicons.dev/icons?i=mysql" width="48" height="48" alt="MySQL" /><br/>MySQL
                </td>
              </tr>

              <tr>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://skillicons.dev/icons?i=git" width="48" height="48" alt="Git" /><br/>Git
                </td>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://img.icons8.com/?size=100&id=D5XsEXNbhkMI&format=png&color=000000" width="48" height="48" alt="GitHub" /><br/>GitHub
                </td>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://img.icons8.com/?size=100&id=yOziZMCSt1Pk&format=png&color=000000" width="48" height="48" alt="DSA" /><br/>DSA
                </td>
                <td align="center" width="140" style={{padding:"10px"}}>
                  <img src="https://img.icons8.com/color/48/000000/code.png" width="48" height="48" alt="Coding" /><br/>Coding
                </td>
              </tr>
            </table>
          </div>



        </div>

      </div>

    </>
  )
}
